import React from "react";
import { useState, useRef, useEffect, useMemo } from "react";
import {
    Box, Typography, Avatar, Chip, Button, IconButton, Grid, TextField,
    Stack, Popper, Grow, Paper, ClickAwayListener, Tabs, Tab, Menu, MenuItem, Collapse
} from "@mui/material";
import moment from "moment";
import TableComponent from "components/grid";
import StatusBadge from "components/badge/StatusBadge";
import CustomPagination from "components/CustomPagination";
import { ReactComponent as EditIcon } from "assets/icons/EditIcon.svg";
import { LuEye, LuRefreshCw, LuSearch } from "react-icons/lu";
import { BiListUl } from "react-icons/bi";
import { MdOutlineFileDownload, MdOutlineFilterAlt } from "react-icons/md";
import { FaPlus } from "react-icons/fa6";
import Select from "react-select";
import CustomButton from "components/Button";
import { useParams } from "react-router-dom";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { useGetAllContactsQuery, } from "store/slices/apis/contactSlice";
import { usePermission } from "hooks/usePermission";
import { exportToExcel } from "utils/ExportToExcel";
import { ERP_DATA_CREATE, ERP_DATA_VIEW } from "helpers/permissionConfig";
import { closeSnackbar, openSnackbar } from "store/slices/snackbar";
import { DEFAULT_DATE_FORMAT } from "config";
import { useDispatch } from "store";
import { useGetLastUpdatedOnStatusQuery } from "store/slices/apis/projectStatusApiSlice";
import ProjectLastUpdatedOn from "components/ProjectLastUpdatedOn";
import TrackerPageHeader from "components/TrackerPageHeader";
import UploadErpData from "./uploadErpData";
import ViewErpData from "./viewErp"
import { useLazyGetErpDataQuery, useLazyGetExportErpDataQuery } from "store/slices/apis/erpDataSlice";

const calenderSVG = (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_894_610)">
            <path d="M12.6667 1.33333H12V0.666667C12 0.489856 11.9298 0.320286 11.8047 0.195262C11.6797 0.0702379 11.5101 0 11.3333 0C11.1565 0 10.987 0.0702379 10.8619 0.195262C10.7369 0.320286 10.6667 0.489856 10.6667 0.666667V1.33333H5.33333V0.666667C5.33333 0.489856 5.2631 0.320286 5.13807 0.195262C5.01305 0.0702379 4.84348 0 4.66667 0C4.48986 0 4.32029 0.0702379 4.19526 0.195262C4.07024 0.320286 4 0.489856 4 0.666667V1.33333H3.33333C2.4496 1.33439 1.60237 1.68592 0.97748 2.31081C0.352588 2.93571 0.00105857 3.78294 0 4.66667L0 12.6667C0.00105857 13.5504 0.352588 14.3976 0.97748 15.0225C1.60237 15.6474 2.4496 15.9989 3.33333 16H12.6667C13.5504 15.9989 14.3976 15.6474 15.0225 15.0225C15.6474 14.3976 15.9989 13.5504 16 12.6667V4.66667C15.9989 3.78294 15.6474 2.93571 15.0225 2.31081C14.3976 1.68592 13.5504 1.33439 12.6667 1.33333ZM1.33333 4.66667C1.33333 4.13623 1.54405 3.62753 1.91912 3.25245C2.29419 2.87738 2.8029 2.66667 3.33333 2.66667H12.6667C13.1971 2.66667 13.7058 2.87738 14.0809 3.25245C14.456 3.62753 14.6667 4.13623 14.6667 4.66667V5.33333H1.33333V4.66667ZM12.6667 14.6667H3.33333C2.8029 14.6667 2.29419 14.456 1.91912 14.0809C1.54405 13.7058 1.33333 13.1971 1.33333 12.6667V6.66667H14.6667V12.6667C14.6667 13.1971 14.456 13.7058 14.0809 14.0809C13.7058 14.456 13.1971 14.6667 12.6667 14.6667Z" fill="#433F5E" />
            <path d="M8 11C8.55228 11 9 10.5523 9 10C9 9.44772 8.55228 9 8 9C7.44772 9 7 9.44772 7 10C7 10.5523 7.44772 11 8 11Z" fill="#433F5E" />
            <path d="M4.66656 11C5.21885 11 5.66656 10.5523 5.66656 10C5.66656 9.44772 5.21885 9 4.66656 9C4.11428 9 3.66656 9.44772 3.66656 10C3.66656 10.5523 4.11428 11 4.66656 11Z" fill="#433F5E" />
            <path d="M11.3334 11C11.8857 11 12.3334 10.5523 12.3334 10C12.3334 9.44772 11.8857 9 11.3334 9C10.7811 9 10.3334 9.44772 10.3334 10C10.3334 10.5523 10.7811 11 11.3334 11Z" fill="#433F5E" />
        </g>
        <defs>
            <clipPath id="clip0_894_610">
                <rect width="16" height="16" fill="white" />
            </clipPath>
        </defs>
    </svg>
);

const tabs = [
    { label: "All", value: "All" },
]




const ErpData = () => {

    const { projectId } = useParams();
    const dispatch = useDispatch()

    const [pageNumber, setPageNumber] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [sortOrder, setSortOrder] = useState('desc');
    const [sortBy, setSortBy] = useState('createdDate');
    const module = "ERPData";


    const [open, setOpen] = useState(false);
    const [tabValue, setTabValue] = useState(0);
    const anchorRef = useRef(null);
    const [isAdd, setIsAdd] = useState(false);
    const [isView, setIsView] = useState(false);
    const [viewData, setViewData] = useState(null);
    const [menuAnchorEl, setMenuAnchorEl] = useState(null);
    const [menuRow, setMenuRow] = useState(null);
    const [searchTerm, setSearchTerm] = useState("");




    const createAccess = usePermission(ERP_DATA_CREATE);
    const viewAccess = usePermission(ERP_DATA_VIEW);
    const req = {
        projectId: projectId
    }

    const [trigger, { data: erpDataList, isFetching }] = useLazyGetErpDataQuery();

    const { data: contactsData, isLoading, error } = useGetAllContactsQuery();



    useEffect(() => {
        const delayDebounceFn = setTimeout(() => {
            if (searchTerm !== filters.SearchTerm) {
                const updatedFilters = {
                    ...filters,
                    SearchTerm: searchTerm,
                    PageNumber: 1,
                };
                setFilters(updatedFilters);
                trigger(updatedFilters);
                setPageNumber(1);
            }
        }, 500);
        return () => clearTimeout(delayDebounceFn);
    }, [searchTerm]);





    const handleMenuOpen = (event, row) => {
        event.stopPropagation();
        setMenuAnchorEl(event.currentTarget);
        setMenuRow(row);
    };


    const handleMenuClose = () => {
        setMenuAnchorEl(null);
        setMenuRow(null);
    };


    const handleMenuView = () => {
        if (menuRow) {
            handleViewClick(menuRow);
        }
        handleMenuClose();
    };


    // const handleMenuEdit = () => {
    //     if (menuRow) {
    //         handleEdit(menuRow);
    //     }
    //     handleMenuClose();
    // };

    const workCategoryOptions = erpDataList?.data
        ?.filter(item => Boolean(item.workCategory?.trim()) && item.workCategory.trim() !== "-")
        ?.map(item => ({
            label: item.workCategory,
            value: item.workCategory
        }));

    const contractorOptions = erpDataList?.data
        ?.filter(item => Boolean(item.contractorName?.trim()) && item.contractorName.trim() !== "-")
        ?.map(item => ({
            label: item.contractorName,
            value: item.contractorName
        }));

    const statusOptions = erpDataList?.data
        ?.filter(item => Boolean(item.status?.trim())&& item.status.trim() !== "-")
        ?.map(item => ({
            label: item.status,
            value: item.status
        }));

    const subCategoryOptions = [
        ...new Set(
            erpDataList?.data
                ?.map(item => item.subCategory)
                ?.filter(item => Boolean(item?.trim()) && item.trim() !== "-")
        )
    ].map(item => ({
        label: item,
        value: item
    }));

    const { data: erpData } = useGetLastUpdatedOnStatusQuery({ ProjectId: projectId });

    const [filters, setFilters] = useState({
        SortBy: sortBy,
        SortOrder: sortOrder,
        PageNumber: pageNumber,
        PageSize: pageSize,
        ProjectId: projectId,
        SearchTerm: "",
    });



    useEffect(() => {
        trigger(filters);
    }, []);


    const handlePageChange = (newPage) => {
        setPageNumber(newPage);
        const updatedFilters = {
            ...filters,
            PageNumber: newPage,
        };
        setFilters(updatedFilters);
        trigger(updatedFilters);
    };


    const handlePageSizeChange = (newSize) => {
        setPageSize(newSize);
        setPageNumber(1);
        const updatedFilters = {
            ...filters,
            PageSize: newSize,
            PageNumber: 1,
        };
        setFilters(updatedFilters);
        trigger(updatedFilters);
    };


    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);

        const updatedFilters = {
            ...filters,
            PageNumber: 1,
            // ...(newValue > 0 ? { type: LEGAL_TYPES[newValue - 1]?.value } : {}),
        };

        if (newValue === 0 && updatedFilters.type) {
            updatedFilters.type = "BOCW";
        }

        setFilters(updatedFilters);
        trigger(updatedFilters);
        setPageNumber(1);
    };


    const handleApplyFilters = () => {
        const updatedFilters = {
            ...filters,
            PageNumber: 1,
        };

        setFilters(updatedFilters);
        trigger(updatedFilters);
        setPageNumber(1);
        handleClose();
    };


    const handleReset = () => {
        const resetFilters = {
            ProjectId: projectId,
            SortBy: sortBy,
            SortOrder: sortOrder,
            PageNumber: 1,
            PageSize: 10,
        };
        setFilters(resetFilters);
        trigger(resetFilters);
        setPageNumber(1);
        handleClose();
    };


    const handleSelectChange = (selectedOption, fieldName) => {
        const updatedFilters = {
            ...filters,
            [fieldName]: selectedOption?.value || "",
            PageNumber: 1,
        };

        setFilters(updatedFilters);
        // trigger(updatedFilters);
        setPageNumber(1);
    };


    const handleDateChange = (e) => {
        const { name, value } = e.target;

        let utcDate = "";
        if (value) {

            const localDate = new Date(value);
            utcDate = localDate.toISOString();
        }

        const updatedFilters = {
            ...filters,
            [name]: utcDate,
            PageNumber: 1,
        };

        setFilters(updatedFilters);
        // trigger(updatedFilters);
        setPageNumber(1);
    };


    const handleRequestSort = (property) => {
        const isAsc = sortBy === property && sortOrder === 'asc';
        const updatedFilters = {
            ...filters,
            SortBy: property,
            SortOrder: isAsc ? 'desc' : 'asc'
        };
        setFilters(updatedFilters);
        setSortOrder(isAsc ? 'desc' : 'asc');
        setSortBy(property);
        trigger(updatedFilters);
    };


    const handleDelete = (filterType) => {
        const updatedFilters = {
            ...filters,
            [filterType]: "",
            PageNumber: 1
        };

        setFilters(updatedFilters);
        trigger(updatedFilters);
        setTabValue(0)
        setPageNumber(1);
    };


    const handleUploadErp = () => {
        setIsAdd((prev) => !prev);
    };

    const handleToggle = () => {
        setOpen((prevOpen) => !prevOpen);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleViewClick = async (row) => {
        try {
            setViewData(row);
            setIsView(true);

        } catch (error) {
            setViewData(row);
            setIsView(true);
        }
    };


    const handleViewClose = () => {
        setIsView(false);
        setViewData(null);
    };

    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value);
    };



    const highlightText = (text, highlight) => {
        if (!highlight || !text) return text;

        const regex = new RegExp(`(${highlight})`, 'gi');
        const parts = String(text).split(regex);

        return parts.map((part, index) =>
            regex.test(part) ? (
                <span
                    key={index}
                    style={{
                        backgroundColor: '#FFF3CD',
                        color: '#856404',
                        fontWeight: 'bold',
                        padding: '0 2px',
                        borderRadius: '3px'
                    }}
                >
                    {part}
                </span>
            ) : part
        );
    };



    const openNotification = (msg, type = "error", duration = 3000) => {
        dispatch(
            openSnackbar({
                open: true,
                message: msg,
                variant: 'alert',
                alert: {
                    color: type
                },
                close: false
            })
        );
        setTimeout(() => dispatch(closeSnackbar()), duration);
    };

    const ALL_EXPORT_COLUMNS = [
        { name: "Work Category", field: "workCategory" },
        { name: "Sub Category", field: "subCategory" },
        { name: "Work Order Number", field: "workOrderNumber" },
        { name: "Work Order Status", field: "workOrderStatus" },
        { name: "Contractor Name", field: "contractorName" },
        { name: "Work Order Value", field: "workOrderValue" },
        { name: "Certificate Type", field: "certificateType" },
        { name: "Invoice No", field: "invoiceNo" },
        { name: "Invoice Date", field: "invoiceDate" },
        { name: "Due Date", field: "dueDate" },
        { name: "Certificate No", field: "certificateNo" },
        { name: "Creation Date", field: "creationDate" },
        { name: "Processed Date", field: "processedDate" },
        { name: "Status", field: "status" },
        { name: "Certified Amount", field: "certifiedAmount" },
        { name: "Discount Amount", field: "discountAmount" },
        { name: "Base Certified Amount", field: "baseCertifiedAmount" },
        { name: "Tax Addition (Inclusive)", field: "taxAdditionInclusive" },
        { name: "Tax Addition (Exclusive)", field: "taxAdditionExclusive" },
        { name: "Material Escalation", field: "materialEscalation" },
        { name: "Gross Bill Amount", field: "grossBillAmount" },
        { name: "Advance Adj. Recovered", field: "advanceAdjRecovered" },
        { name: "Misc Adj. Recovered", field: "miscAdjRecovered" },
        { name: "Material Adj Recovered", field: "materialAdjRecovered" },
        { name: "Debit Note Adj. Recovered", field: "debitNoteAdjRecovered" },
        { name: "Tax Deduction", field: "taxDeduction" },
        { name: "Retention Amount", field: "retentionAmount" },
        { name: "Other Deduction", field: "otherDeduction" },
        { name: "Cheque.No/ Cheque.Dt", field: "chequeNoOrDetails" },
        { name: "Cheque Amount", field: "chequeAmount" },
        { name: "Amount Payable", field: "amountPayable" },
        { name: "Amount Paid", field: "amountPaid" },
        { name: "Outstanding Amount", field: "outstandingAmount" },
        { name: "Remarks", field: "remarks" },
    ];

    const [triggerExport, { isFetching: isExporting }] = useLazyGetExportErpDataQuery();
    const handleExportExcel = async () => {
        try {
            const exportFilters = {
                ...filters,
                PageNumber: 1,
                PageSize: 5000,
            };

            const response = await triggerExport(exportFilters).unwrap();
            const rows = response?.data || [];

            if (!Array.isArray(rows) || rows.length === 0) {
                openNotification("No data available to export", "warning");
                return;
            }

            const formattedData = rows.map((row, index) => {
                const rowData = {
                    "S.No": index + 1,
                };

                ALL_EXPORT_COLUMNS.forEach((col) => {
                    let value = row?.[col.field];

                    if (
                        col.field.toLowerCase().includes("date") &&
                        value
                    ) {
                        value = moment(value).isValid()
                            ? moment(value).format("DD-MM-YYYY")
                            : "N/A";
                    }

                    rowData[col.name] =
                        value !== undefined &&
                            value !== null &&
                            value !== ""
                            ? value
                            : "N/A";
                });

                return rowData;
            });

            exportToExcel(
                formattedData,
                "erp_data",
                "ERP Data"
            );

            openNotification("Excel exported successfully", "success");
        } catch (error) {
            console.error("Export error:", error);
            openNotification("Failed to export Excel", "error");
        }
    };

    const columns = [
        {
            name: "",
            field: "actions",
            sticky: true,
            width: "10px",
            renderer: (row) => (
                <>
                    {(viewAccess) &&
                        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                            <IconButton
                                size="small"
                                onClick={(e) => handleMenuOpen(e, row)}
                            >
                                <MoreVertIcon fontSize="small" />
                            </IconButton>
                        </Box>
                    }
                </>
            ),
        },
        // {
        //     name: "ID",
        //     field: "customId",
        //     width: "100px",
        //     sticky: true,
        // },
        {
            name: "Work Category",
            field: "workCategory",
            sticky: true,
            renderer: (row) => (
                <>
                    {row?.workCategory || "-"}
                </>
            ),
        },
        {
            name: "Sub Category",
            field: "subCategory",
            renderer: (row) => (
                <>
                    {row?.subCategory || "-"}
                </>
            ),
        },
        {
            name: "Work Order Number",
            field: "workOrderNumber",
            renderer: (row) => row?.workOrderNumber ? highlightText(row.workOrderNumber, searchTerm) : "N/A",
        },
        {
            name: "Work Order Status",
            field: "workOrderStatus",
            renderer: (row) => (
                <>
                    {row?.workOrderStatus || "-"}
                </>
            ),
        },
        {
            name: "Contractor Name",
            field: "contractorName",
            renderer: (row) => row?.contractorName ? highlightText(row.contractorName, searchTerm) : "N/A",
        },
        {
            name: "Work Order Value",
            field: "workOrderValue",
        },
        {
            name: "Certificate Type",
            field: "certificateType",
            renderer: (row) => (
                <>
                    {row?.certificateType || "-"}
                </>
            ),
        },
        {
            name: "Invoice No",
            field: "invoiceNo",
            renderer: (row) => row?.invoiceNo ? highlightText(row.invoiceNo, searchTerm) : "N/A",
        },
        {
            name: "Invoice Date",
            field: "invoiceDate",
            renderer: (row) => (
                <>
                    {row?.invoiceDate
                        ? moment(row?.invoiceDate).format("DD-MM-YYYY")
                        : "-"}
                </>
            ),
        },
        {
            name: "Due Date",
            field: "dueDate",
            renderer: (row) => (
                <>
                    {row?.dueDate
                        ? moment(row?.dueDate).format("DD-MM-YYYY")
                        : "-"}
                </>
            ),
        },
        {
            name: "Certificate No",
            field: "certificateNo",
            renderer: (row) => (
                <>
                    {row?.certificateNo || "-"}
                </>
            ),
        },
        {
            name: "Creation Date",
            field: "creationDate",
            renderer: (row) => (
                <>
                    {row?.creationDate
                        ? moment(row?.creationDate).format("DD-MM-YYYY")
                        : "-"}
                </>
            ),
        },
        {
            name: "Processed Date",
            field: "processedDate",
            renderer: (row) => (
                <>
                    {row?.processedDate
                        ? moment(row?.processedDate).format("DD-MM-YYYY")
                        : "-"}
                </>
            ),
        },
        {
            name: "Status",
            field: "status",
            renderer: (row) => (
                <>
                    {row?.status || "-"}
                </>
            ),
        },
        {
            name: "Certified Amount",
            field: "certifiedAmount",
            renderer: (row) => (
                <>
                    {row?.certifiedAmount || "-"}
                </>
            ),
        },
        {
            name: "Discount Amount",
            field: "discountAmount",
            renderer: (row) => (
                <>
                    {row?.discountAmount || "-"}
                </>
            ),
        },
        {
            name: "Base Certified Amount",
            field: "baseCertifiedAmount",
            renderer: (row) => (
                <>
                    {row?.baseCertifiedAmount || "-"}
                </>
            ),
        },
        {
            name: "Tax Addition (Inclusive)",
            field: "taxAdditionInclusive",
            renderer: (row) => (
                <>
                    {row?.taxAdditionInclusive || "-"}
                </>
            ),
        },
        {
            name: "Tax Addition (Exclusive)",
            field: "taxAdditionExclusive",
            renderer: (row) => (
                <>
                    {row?.taxAdditionExclusive || "-"}
                </>
            ),
        },
        {
            name: "Material Escalation",
            field: "materialEscalation",
            renderer: (row) => (
                <>
                    {row?.materialEscalation || "-"}
                </>
            ),
        },
        {
            name: "Gross Bill Amount",
            field: "grossBillAmount",
            renderer: (row) => (
                <>
                    {row?.grossBillAmount || "-"}
                </>
            ),
        },
        {
            name: "Advance Adj. Recovered",
            field: "advanceAdjRecovered",
            renderer: (row) => (
                <>
                    {row?.advanceAdjRecovered || "-"}
                </>
            ),
        },
        {
            name: "Misc Adj. Recovered",
            field: "miscAdjRecovered",
            renderer: (row) => (
                <>
                    {row?.miscAdjRecovered || "-"}
                </>
            ),
        },
        {
            name: "Material Adj Recovered",
            field: "materialAdjRecovered",
            renderer: (row) => (
                <>
                    {row?.materialAdjRecovered || "-"}
                </>
            ),
        },
        {
            name: "Debit Note Adj. Recovered",
            field: "debitNoteAdjRecovered",
            renderer: (row) => (
                <>
                    {row?.debitNoteAdjRecovered || "-"}
                </>
            ),
        },
        {
            name: "Tax Deduction",
            field: "taxDeduction",
            renderer: (row) => (
                <>
                    {row?.taxDeduction || "-"}
                </>
            ),
        },
        {
            name: "Retention Amount",
            field: "retentionAmount",
            renderer: (row) => (
                <>
                    {row?.retentionAmount || "-"}
                </>
            ),
        },
        {
            name: "Other Deduction",
            field: "otherDeduction",
            renderer: (row) => (
                <>
                    {row?.otherDeduction || "-"}
                </>
            ),
        },
        {
            name: "Cheque.No/ Cheque.Dt",
            field: "chequeNoOrDetails",
            renderer: (row) => (
                <>
                    {row?.chequeNoOrDetails || "-"}
                </>
            ),
        },
        {
            name: "Cheque Amount",
            field: "chequeAmount",
            renderer: (row) => (
                <>
                    {row?.chequeAmount || "-"}
                </>
            ),
        },
        {
            name: "Amount Payable",
            field: "amountPayable",
            renderer: (row) => (
                <>
                    {row?.amountPayable || "-"}
                </>
            ),
        },
        {
            name: "Amount Paid",
            field: "amountPaid",
            renderer: (row) => (
                <>
                    {row?.amountPaid || "-"}
                </>
            ),
        },
        {
            name: "Outstanding Amount",
            field: "outstandingAmount",
            renderer: (row) => (
                <>
                    {row?.outstandingAmount || "-"}
                </>
            ),
        },
        {
            name: "Remarks",
            field: "remarks",
            renderer: (row) => (
                <>
                    {row?.remarks || "-"}
                </>
            ),
        },
    ];


    return (
        <>
            <TrackerPageHeader title="ERP Data" description="Review imported ERP records, payment details, and reconciliation data.">
                <ProjectLastUpdatedOn date={erpData?.erplastUpdated} isLoading={isFetching} />
            </TrackerPageHeader>
            <Grid container spacing={2} sx={{ p: 2 }}>


                <Grid size={12}>
                    <Box
                        sx={{
                            width: "100%",
                            borderBottom: "2px solid #ECECEC",
                            overflowX: "auto",
                            whiteSpace: "nowrap",
                            p: 0,
                            display: "flex", alignItems: "center", justifyContent: 'space-between',
                            "-webkit-overflow-scrolling": "touch",
                        }}
                    >
                        <Tabs
                            value={tabValue}
                            onChange={handleTabChange}
                            TabIndicatorProps={{ style: { display: "none" } }}
                            variant="scrollable"
                            scrollButtons={false}
                            sx={{
                                justifyContent: "flex-start !important",
                                alignItems: "flex-start",
                                "& .MuiTabs-flexContainer": {
                                    justifyContent: "flex-start !important",
                                    gap: "30px",
                                },
                            }}
                        >
                            {tabs.map((item, index) => {
                                return (
                                    <Tab
                                        key={index}
                                        label={
                                            <Box sx={{ display: "flex", alignItems: "center", gap: "6px" }}>
                                                <Typography
                                                    sx={{
                                                        fontWeight: 500,
                                                        fontSize: "14px",
                                                        lineHeight: "100%",
                                                        color: tabValue === index ? "#0E73F6" : "#7E7E7E",
                                                        fontFamily: "Outfit, sans-serif"
                                                    }}
                                                >
                                                    {item.label}
                                                </Typography>

                                                <Chip
                                                    label={erpDataList?.totalRecords || 0}
                                                    sx={{
                                                        height: "20px",
                                                        fontSize: "14px",
                                                        fontWeight: 500,
                                                        lineHeight: 1,
                                                        backgroundColor: "#E5E9EB",
                                                        color: "#5F5F5F",
                                                    }}
                                                />


                                            </Box>
                                        }
                                        sx={{
                                            textTransform: "none",
                                            minWidth: "auto",
                                            paddingBottom: "14px",
                                            paddingLeft: 0,
                                            paddingRight: 0,
                                            borderBottom: tabValue === index ? "2px solid #0E73F6" : "2px solid transparent",
                                        }}
                                    />
                                );
                            })}
                        </Tabs>
                        {createAccess &&
                            <CustomButton
                                label="Upload ERP Data"
                                startIcon={<FaPlus />}
                                color="primary"
                                onClick={handleUploadErp}
                                sx={{
                                    backgroundColor: "#2563EB",
                                    fontFamily: 'Outfit',
                                    fontWeight: 500,
                                    fontSize: '14px',
                                    lineHeight: '100%',
                                    letterSpacing: '0px',
                                }}
                            />
                        }
                    </Box>
                </Grid>


                <Grid size={12}>
                    <Grid container>
                        <Grid size={{ md: 8, sm: 12 }}>
                            <Stack
                                direction="row"
                                spacing={1}
                                flexWrap="wrap"
                                sx={{
                                    padding: "8px 0",
                                    alignItems: "center",
                                    minHeight: "40px"
                                }}
                            >

                                {filters.WorkCategory && (
                                    <Chip
                                        label={<Typography variant="body2"><strong style={{ color: '#0E73F6' }}>Work Category:</strong> <span style={{ fontWeight: 400, color: "#6B7280" }}>{filters.WorkCategory}</span></Typography>}
                                        sx={{ backgroundColor: "rgba(25, 118, 210, 0.08)", border: 0 }}
                                        onDelete={() => handleDelete('WorkCategory')}
                                    />
                                )}
                                {filters.ContractorName && (
                                    <Chip
                                        label={<Typography variant="body2"><strong style={{ color: '#0E73F6' }}>Contractor Name:</strong> <span style={{ fontWeight: 400, color: "#6B7280" }}>{filters.ContractorName}</span></Typography>}
                                        sx={{ backgroundColor: "rgba(25, 118, 210, 0.08)", border: 0 }}
                                        onDelete={() => handleDelete('ContractorName')}
                                    />
                                )}
                                {filters.Status && (
                                    <Chip
                                        label={<Typography variant="body2"><strong style={{ color: '#0E73F6' }}>Status:</strong> <span style={{ fontWeight: 400, color: "#6B7280" }}>{filters.Status}</span></Typography>}
                                        sx={{ backgroundColor: "rgba(25, 118, 210, 0.08)", border: 0 }}
                                        onDelete={() => handleDelete('Status')}
                                    />
                                )}
                                {filters.SubCategory && (
                                    <Chip
                                        label={<Typography variant="body2"><strong style={{ color: '#0E73F6' }}>Sub Category:</strong> <span style={{ fontWeight: 400, color: "#6B7280" }}>{filters.SubCategory}</span></Typography>}
                                        sx={{ backgroundColor: "rgba(25, 118, 210, 0.08)", border: 0 }}
                                        onDelete={() => handleDelete('SubCategory')}
                                    />
                                )}
                                {filters.DueDate && (
                                    <Chip
                                        label={<Typography variant="body2"><strong style={{ color: '#0E73F6' }}>Due Date:</strong>
                                            <span style={{ fontWeight: 400, color: "#6B7280" }}>
                                                {moment(filters.DueDate).format("DD-MM-YYYY")}
                                            </span>
                                        </Typography>}
                                        sx={{ backgroundColor: "rgba(25, 118, 210, 0.08)", border: 0 }}
                                        onDelete={() => handleDelete('DueDate')}
                                    />
                                )}

                                {filters.InvoiceDate && (
                                    <Chip
                                        label={<Typography variant="body2">
                                            <strong style={{ color: '#0E73F6' }}>Invoice Date:</strong>
                                            <span style={{ fontWeight: 400, color: "#6B7280" }}>{moment(filters.InvoiceDate).format("DD-MM-YYYY")}</span>
                                        </Typography>}
                                        sx={{ backgroundColor: "rgba(25, 118, 210, 0.08)", border: 0 }}
                                        onDelete={() => handleDelete('InvoiceDate')}
                                    />
                                )}

                            </Stack>
                        </Grid>


                        <Grid size={{ md: 4, sm: 12 }}>
                            <Box
                                sx={{
                                    display: "flex",
                                    flexDirection: { md: "row", xs: "column" },
                                    alignItems: { md: "center", xs: "flex-start" },
                                    justifyContent: 'end',
                                    p: "8px 0px"
                                }}
                            >
                                <TextField
                                    placeholder="Search by Work Order Number, Contractor, Invoice No..."
                                    value={searchTerm}
                                    onChange={handleSearchChange}
                                    variant="outlined"
                                    size="small"
                                    InputProps={{
                                        startAdornment: <LuSearch style={{ marginRight: '8px', color: '#6B7280' }} />,
                                    }}
                                    sx={{
                                        minWidth: { md: '450px', xs: "auto" },
                                        backgroundColor: '#fff',
                                        '& .MuiOutlinedInput-root': { borderRadius: '3px', minHeight: '36px', fontSize: '13px' },
                                        '& .MuiInputBase-input::placeholder': {
                                            fontSize: '0.9rem',
                                        }
                                    }}
                                    type="search"
                                />
                                <IconButton
                                    ref={anchorRef}
                                    onClick={handleToggle}
                                >
                                    <MdOutlineFilterAlt size={24} color="#48535B" />
                                </IconButton>
                                <IconButton
                                    onClick={handleExportExcel}
                                >
                                    <MdOutlineFileDownload size={24} color="#48535B" />
                                </IconButton>


                                <Popper
                                    open={open}
                                    anchorEl={anchorRef.current}
                                    placement="bottom-end"
                                    transition
                                    disablePortal={false}
                                    sx={{ zIndex: 2000 }}
                                >
                                    {({ TransitionProps }) => (
                                        <Grow {...TransitionProps}>
                                            <Paper
                                                sx={{
                                                    mt: 1,
                                                    p: 2,
                                                    borderRadius: 1,
                                                    boxShadow: "0px 4px 20px rgba(7, 7, 7, 0.08)",
                                                    width: 600,
                                                }}
                                            >
                                                <ClickAwayListener onClickAway={handleClose}>
                                                    <Box>
                                                        <Grid container spacing={2}>


                                                            <Grid size={6}>
                                                                <Typography sx={{ fontFamily: 'Outfit', fontWeight: 500, fontSize: '16px', mb: 1 }}>Work Category</Typography>
                                                                <Select
                                                                    options={workCategoryOptions}
                                                                    placeholder="Select Work Category"
                                                                    onChange={(option) => handleSelectChange(option, "WorkCategory")}
                                                                    value={workCategoryOptions.find(opt => opt.value === filters.WorkCategory) || null}
                                                                />
                                                            </Grid>
                                                            <Grid size={6}>
                                                                <Typography sx={{ fontFamily: 'Outfit', fontWeight: 500, fontSize: '16px', mb: 1 }}>Sub Category</Typography>
                                                                <Select
                                                                    options={subCategoryOptions}
                                                                    placeholder="Select Sub Category"
                                                                    onChange={(option) => handleSelectChange(option, "SubCategory")}
                                                                    value={subCategoryOptions.find(opt => opt.value === filters.SubCategory) || null}
                                                                />
                                                            </Grid>
                                                            <Grid size={6}>
                                                                <Typography sx={{ fontFamily: 'Outfit', fontWeight: 500, fontSize: '16px', mb: 1 }}>Contractor Name</Typography>
                                                                <Select
                                                                    options={contractorOptions}
                                                                    placeholder="Select Contractor"
                                                                    onChange={(option) => handleSelectChange(option, "ContractorName")}
                                                                    value={contractorOptions.find(opt => opt.value === filters.ContractorName) || null}
                                                                />
                                                            </Grid>
                                                            <Grid size={6}>
                                                                <Typography sx={{ fontFamily: 'Outfit', fontWeight: 500, fontSize: '16px', mb: 1 }}>Status</Typography>
                                                                <Select
                                                                    options={statusOptions}
                                                                    placeholder="Select Status"
                                                                    onChange={(option) => handleSelectChange(option, "Status")}
                                                                    value={statusOptions.find(opt => opt.value === filters.Status) || null}
                                                                />
                                                            </Grid>

                                                            <Grid size={6}>
                                                                <Typography sx={{
                                                                    fontFamily: 'Outfit',
                                                                    fontWeight: 500,
                                                                    fontSize: '16px',
                                                                    lineHeight: '100%',
                                                                    letterSpacing: "0px",
                                                                    mb: 1
                                                                }}>Due Date</Typography>
                                                                <TextField
                                                                    type="date"
                                                                    name="DueDate"
                                                                    value={filters.DueDate ? new Date(filters.DueDate).toISOString().split('T')[0] : ""}
                                                                    onChange={handleDateChange}
                                                                    onClick={(e) => {
                                                                        const input = e.currentTarget.parentElement?.querySelector('input[type="date"]');
                                                                        if (input) input.showPicker?.();
                                                                    }}
                                                                    fullWidth
                                                                    sx={{
                                                                        "& input::-webkit-calendar-picker-indicator": {
                                                                            display: "none",
                                                                            WebkitAppearance: "none",
                                                                        },
                                                                        "& input[type='date']": {
                                                                            appearance: "none",
                                                                            WebkitAppearance: "none",
                                                                        },
                                                                        "& .MuiOutlinedInput-root": {
                                                                            "& fieldset": {
                                                                                border: "none",
                                                                            },
                                                                        },
                                                                    }}
                                                                    InputProps={{
                                                                        startAdornment: (
                                                                            <Box sx={{ ml: 2, mr: 1, color: "#433F5E", display: "flex", alignItems: "center", cursor: "pointer" }}

                                                                            >
                                                                                {calenderSVG}
                                                                            </Box>
                                                                        ),
                                                                        sx: {
                                                                            backgroundColor: "#E7E7EB",
                                                                            height: "40px",
                                                                            width: { xs: "100%", md: "100%" },
                                                                            borderRadius: "3px",
                                                                        },
                                                                    }}
                                                                />
                                                            </Grid>
                                                            <Grid size={6}>
                                                                <Typography sx={{
                                                                    fontFamily: 'Outfit',
                                                                    fontWeight: 500,
                                                                    fontSize: '16px',
                                                                    lineHeight: '100%',
                                                                    letterSpacing: "0px",
                                                                    mb: 1
                                                                }}>Invoice Date</Typography>
                                                                <TextField
                                                                    type="date"
                                                                    name="InvoiceDate"
                                                                    value={filters.InvoiceDate ? new Date(filters.InvoiceDate).toISOString().split('T')[0] : ""}
                                                                    onChange={handleDateChange}
                                                                    onClick={(e) => {
                                                                        const input = e.currentTarget.parentElement?.querySelector('input[type="date"]');
                                                                        if (input) input.showPicker?.();
                                                                    }}
                                                                    fullWidth
                                                                    sx={{
                                                                        "& input::-webkit-calendar-picker-indicator": {
                                                                            display: "none",
                                                                            WebkitAppearance: "none",
                                                                        },
                                                                        "& input[type='date']": {
                                                                            appearance: "none",
                                                                            WebkitAppearance: "none",
                                                                        },
                                                                        "& .MuiOutlinedInput-root": {
                                                                            "& fieldset": {
                                                                                border: "none",
                                                                            },
                                                                        },
                                                                    }}
                                                                    InputProps={{
                                                                        startAdornment: (
                                                                            <Box sx={{ ml: 2, mr: 1, color: "#433F5E", display: "flex", alignItems: "center", cursor: "pointer" }}

                                                                            >
                                                                                {calenderSVG}
                                                                            </Box>
                                                                        ),
                                                                        sx: {
                                                                            backgroundColor: "#E7E7EB",
                                                                            height: "40px",
                                                                            width: { xs: "100%", md: "100%" },
                                                                            borderRadius: "3px",
                                                                        },
                                                                    }}
                                                                />
                                                            </Grid>

                                                            <Grid size={12}>
                                                                <Box
                                                                    sx={{
                                                                        display: "flex",
                                                                        justifyContent: "flex-end",
                                                                        alignItems: "center",
                                                                    }}
                                                                >
                                                                    <Button onClick={handleReset}
                                                                        sx={{
                                                                            textTransform: "none",
                                                                            color: "#F15744",
                                                                            fontSize: "14px",
                                                                            lineHeight: "100%",
                                                                            fontFamily: "Outfit, sans-serif",
                                                                            borderRadius: "3px",
                                                                            fontWeight: 500,
                                                                            px: "20px",
                                                                            py: "15px",
                                                                        }}>
                                                                        Reset
                                                                    </Button>
                                                                    <Button
                                                                        type="button"
                                                                        onClick={handleApplyFilters}
                                                                        variant="contained"
                                                                        sx={{
                                                                            backgroundColor: "#2563EB",
                                                                            borderRadius: "3px",
                                                                            textTransform: "none",
                                                                            fontWeight: 500,
                                                                            fontSize: "14px",
                                                                            lineHeight: "100%",
                                                                            fontFamily: "Outfit, sans-serif",
                                                                            color: "#FFFFFF",
                                                                            px: "20px",
                                                                            py: "15px",
                                                                        }}
                                                                    >
                                                                        Apply
                                                                    </Button>
                                                                </Box>
                                                            </Grid>
                                                        </Grid>
                                                    </Box>
                                                </ClickAwayListener>
                                            </Paper>
                                        </Grow>
                                    )}
                                </Popper>

                                <IconButton
                                    onClick={() => trigger(filters)}
                                >
                                    <LuRefreshCw size={20} color="#48535B" />
                                </IconButton>
                            </Box>
                        </Grid>
                    </Grid>
                </Grid>


                <Grid size={12}>
                    <TableComponent
                        columns={columns}
                        data={erpDataList?.data || []}
                        createSortHandler={handleRequestSort}
                        isLoading={isFetching}
                        order={sortOrder}
                        orderBy={sortBy}

                    />
                    <Menu
                        anchorEl={menuAnchorEl}
                        open={Boolean(menuAnchorEl)}
                        onClose={handleMenuClose}
                        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                        transformOrigin={{ vertical: "top", horizontal: "right" }}
                        PaperProps={{
                            elevation: 0,
                            sx: {
                                mt: 1,
                                borderRadius: "3px",
                                minWidth: 140,
                                border: "1px solid #E5E9EB",
                                boxShadow: "0px 10px 30px rgba(15, 23, 42, 0.12)",
                                overflow: "hidden",
                            },
                        }}
                        MenuListProps={{
                            sx: {
                                py: 0.5,
                            },
                        }}
                    >
                        {viewAccess &&
                            <MenuItem
                                onClick={handleMenuView}
                                sx={{
                                    fontFamily: "Outfit, sans-serif",
                                    fontSize: "14px",
                                    fontWeight: 400,
                                    px: 1.5,
                                    py: 1,
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 1,
                                    color: "#111827",
                                    "&:hover": {
                                        backgroundColor: "#F6F8F9",
                                    },
                                }}
                            >
                                <LuEye size={16} style={{ color: "#4B5563" }} />
                                <span>View</span>
                            </MenuItem>
                        }
                        {/* {editAccess && <MenuItem
                            onClick={handleMenuEdit}
                            sx={{
                                fontFamily: "Outfit, sans-serif",
                                fontSize: "14px",
                                fontWeight: 400,
                                px: 1.5,
                                py: 1,
                                display: "flex",
                                alignItems: "center",
                                gap: 1,
                                color: "#111827",
                                "&:hover": {
                                    backgroundColor: "#F6F8F9",
                                },
                            }}
                        >
                            <EditIcon style={{ width: 14, height: 14 }} />
                            <span>Edit</span>
                        </MenuItem>
                        } */}
                    </Menu>

                    <CustomPagination
                        totalCount={erpDataList?.totalRecords || 0}
                        pageSize={pageSize}
                        page={pageNumber}
                        onPageChange={handlePageChange}
                        setCurrentPage={setPageNumber}
                        onPageSizeChange={handlePageSizeChange}
                    />
                </Grid>
            </Grid>
            {isAdd && <UploadErpData open={isAdd} handleClose={handleUploadErp} />}
            {isView && <ViewErpData open={isView} handleClose={handleViewClose} rowData={viewData} />}

        </>
    );
}

export default ErpData;
